export const decToHexStr = (n: number):string =>{
    const hexStr = n.toString(16);
    if (hexStr.length % 2 !== 0) {
        return "0" + hexStr;
    }

    return hexStr;
}